// extracted by mini-css-extract-plugin
module.exports = {"default":"Message_default__1uopq","error":"Message_error__1vuni","info":"Message_info__2vdjS","success":"Message_success__2oSlJ"};